export default "__VITE_ASSET__CGhqpPrr__"